import React from "react";
import { Button, Text } from "@networkraildigitalfactory/components";
import BackButton from "../../../assets/arrow-left.png";
import styles from "./CarouselModal.module.css";

const Screen = (props) => {
  const { firstScreen, lastScreen, prev, imgSrc, imgAlt, heading, bodyText, onButtonClick } = props;
  return (
    <div className={styles.wrapper}>
      {!firstScreen && (
        <img
          src={BackButton}
          role="button"
          alt="Arrow Left"
          className={styles.leftArrowBtn}
          onClick={prev}
          tabIndex={-1}
        />
      )}
      <div className={`${styles.main_content_wrapper} ${firstScreen ? styles.firstScreen : ""}`}>
        <div className={styles.image_wrapper}>
          <img src={imgSrc} alt={imgAlt} className={styles.heading_img} />
        </div>
        {heading && (
          <Text
            type="header"
            style={{
              fontSize: 40,
              margin: "20px 0px 20px 0px",
              letterSpacing: "0.0015em",
            }}
          >
            {heading}
          </Text>
        )}
        {bodyText.map((paragraph, index) => {
          return (
            <Text key={index} style={paragraph.style} color="#000000">
              {paragraph.text}
              {paragraph.image}
              {paragraph.link}
            </Text>
          );
        })}
        <Button
          color="blue"
          style={lastScreen ? { width: "150px", height: "40px" } : {}}
          text={lastScreen ? "Get started" : "Next"}
          onClick={onButtonClick}
          tabIndex={-1}
        />
      </div>
    </div>
  );
};

export default Screen;
